import { Box, Checkbox, FormControl } from '@primer/react';
import { Controller, useForm } from 'react-hook-form';
import { useDispatch, useSelector } from 'react-redux';
import SelectBoxHocSinh from '../../../../components/selectbox-hocsinh';
import Button from '../../../../components/ui/button';
import Modal from '../../../../components/ui/modal';
import ModalActions from '../../../../components/ui/modal/ModalActions';
import Text from '../../../../components/ui/text';
import TextAreaAutoHeight from '../../../../components/ui/text-area-auto-height';
import { useCommonSelectedHook } from '../../../../hooks/useCommonSelectedHook';
import { ePageBaseStatus } from '../../../../models/ePageBaseStatus';
import { IHocSinhAceChitietVM } from '../../../../models/response/hoc-sinh/IHocSinhAceChitiet';
import { actions } from '../../../../state/actions/actionsWrapper';
import { RootState } from '../../../../state/reducers';
import { IHocSinhAceChiTietSubmit } from '../../../../models/request/hoc-sinh/IHocSinhAceChiTietSubmit';
import SelectBoxMienGiam from '../../../../components/selectbox-miengiam';
import { HocSinh } from '../../gia-dinh/QuanHeGiaDinhHocSinh';
import { IConCbnv } from '../../../../models/response/hoc-sinh/IConCbnv';
import SelectBoxThongTinCbnv from '../../../../components/selectbox-thongtin-cnbv';
import ComboboxQuanHeCbnv from '../../../../components/combobox-quanhe-cbnv';
import ComboboxQuanHe from '../../../../components/combobox-quanhe/ComboboxQuanHe';
import ComboBoxGiaoVien from '../../../../components/combobox-giaovien';
interface Props {
    hocSinh: HocSinh;
}
const ConEmGiaoVienEditModal: React.FC<Props> = ({ hocSinh }) => {
    const { status, editingData } = useSelector((x: RootState) => x.conCbnv)
    const dispatch = useDispatch();
    const { dm_coso_id, nam_hoc } = useCommonSelectedHook();
    const { handleSubmit, setValue, watch, control, formState: { errors } } = useForm<IConCbnv>({
        defaultValues: editingData ? {
            ...editingData,
        } : undefined
    })
    const onSubmit = async (data: any) => {
        dispatch(actions.conCbnv.SAVE_START({
            ...data,
            id: data?.id ?? 0,
            ts_hocsinh_id: hocSinh.id,
            nam_hoc: nam_hoc
        }))
    }

    return (
        <Modal isOpen
            title={editingData ? "Base.Label.Edit" : "Base.Label.AddNew"}
            onClose={() => {
                dispatch(actions.conCbnv.CLOSE_EDIT_MODAL(undefined))
            }}
        >
            <form onSubmit={handleSubmit(onSubmit)}>
                <Box sx={{ display: "grid", gap: 2 }}>
                    <FormControl>
                        <FormControl.Label><Text text='CBNV' /></FormControl.Label>
                        <Controller
  name="ts_thongtin_cbnv_id"
  control={control}
  rules={{
    required: {
      value: true,
      message: ""
    }
  }}
  render={({ field, fieldState: { error } }) => (
    <>
      <SelectBoxThongTinCbnv
        isReadonly={editingData !== undefined && editingData.id > 0}
        value={field.value} 
        isShowClearBtn={true}
        onValueChanged={(value, data) => {
          field.onChange(value);
        }}
        width={'100%'}
        maxWidth={300}
      />
      {
        errors && errors["ts_thongtin_cbnv_id"] &&
        <FormControl.Validation variant="error">
          Vui lòng chọn CBNV
        </FormControl.Validation>
      }
    </>
  )}
/>

                        {/* <Controller
                            name="sis_giaovien_id"
                            control={control}
                            rules={{
                                required: {
                                    value: true,
                                    message: ""
                                }
                            }}
                            render={({ field, fieldState: { error } }) => (
                                <>                             
                                    <ComboBoxGiaoVien
                                        isReadonly={editingData !== undefined && editingData.id > 0}
                                        value={field.value}
                                        isShowClearBtn={true}
                                        onValueChanged={(value) => {
                                            field.onChange(value);
                                        }}
                                        width={'100%'}
                                        dm_truong_id={0}
                                    />
                                    {
                                        errors && errors["sis_giaovien_id"] &&
                                        <FormControl.Validation variant="error">
                                            Vui lòng chọn CBNV
                                        </FormControl.Validation>
                                    }
                                </>
                            )}
                        /> */}

                    </FormControl>
                    <FormControl>
                        <FormControl.Label><Text text='Quan hệ' /></FormControl.Label>
                        <Controller
                            name="dm_quanhe_id"
                            control={control}
                            rules={{
                                required: {
                                    value: true,
                                    message: ""
                                }
                            }}
                            render={({ field, fieldState: { error } }) => (
                                <>
                                    <ComboboxQuanHe
                                        value={field.value}
                                        isShowClearButton={true}
                                        onValueChanged={(value) => {
                                            field.onChange(value);
                                        }}
                                        width={'100%'}
                                    />
                                    {
                                        errors && errors["dm_quanhe_id"] &&
                                        <FormControl.Validation variant="error">
                                            Vui lòng chọn quan hệ CBNV
                                        </FormControl.Validation>
                                    }
                                </>
                            )}
                        />

                    </FormControl>
                    <FormControl sx={{ pt: 1 }}>
                        <FormControl.Label>Hưởng ưu đãi</FormControl.Label>
                        <Checkbox
                            checked={watch("is_huonguudai", editingData?.is_huonguudai)}
                            onChange={(e) => {
                                setValue("is_huonguudai", e.target.checked);
                            }}
                        />
                    </FormControl>
                    {watch("is_huonguudai", editingData?.is_huonguudai) && (
                        <FormControl sx={{ pt: 1 }}>
                            <FormControl.Label>
                                <Text text="Ưu đãi, miễn giảm" />
                            </FormControl.Label>

                            <Controller
                                name="sf_hinhthucmiengiam_id"
                                control={control}
                                rules={{
                                    required: {
                                        value: true,
                                        message: ""
                                    }
                                }}
                                render={({ field }) => (
                                    <>
                                        <SelectBoxMienGiam
                                            value={field.value}
                                            isShowClearBtn={true}
                                            onValueChanged={(value) => {
                                                field.onChange(value);
                                            }}
                                            width={"100%"}
                                        />
                                        {
                                            errors && errors["sf_hinhthucmiengiam_id"] &&
                                            <FormControl.Validation variant="error">
                                                Vui lòng chọn ưu đãi miễn giảm được hưởng
                                            </FormControl.Validation>
                                        }
                                    </>
                                )}
                            />


                        </FormControl>
                    )}
                    <FormControl>
                        <FormControl.Label>
                            Ghi chú
                        </FormControl.Label>
                        <Controller
                            name="ghi_chu"
                            control={control}
                            rules={{
                                required: {
                                    value: false,
                                    message: ""
                                }
                            }}
                            render={({ field }) => (
                                <TextAreaAutoHeight
                                    defaultValue={field.value}
                                    isAutoFocus
                                    sx={{
                                        width: "100%"
                                    }}
                                    resize="none"
                                    onValueChanged={(value) => {
                                        field.onChange(value)
                                    }}
                                />
                            )}
                        />
                    </FormControl>
                </Box>

                <ModalActions>

                    <Button
                        text='Base.Label.Close' variant="default"
                        leadingVisual={'center'}
                        size="small"
                        onClick={() => {
                            dispatch(actions.conCbnv.CLOSE_EDIT_MODAL(undefined))
                        }} />
                    <Button
                        text='Base.Label.Update' variant="primary"
                        size="small"
                        type='submit'
                        isLoading={status === ePageBaseStatus.is_saving}
                    />
                </ModalActions>
            </form>

        </Modal>
    );
};

export default ConEmGiaoVienEditModal;